module.exports = __webpack_public_path__ + "img/index-section6-friend9.d9ffa5a7.svg";